import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appToggleLabel]',
})
export class ToggleLabelDirective implements OnInit {
  @Input() onText = 'ON';
  @Input() offText = 'OFF';

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    // Create and style the label element
    const label = this.renderer.createElement('label');
    label.className = 'tgl-btn m-0'; // Add your CSS classes here

    // Set the 'for' attribute
    label.setAttribute('for', this.el.nativeElement.getAttribute('for'));

    // Create and style the "ON" label
    const onLabel = this.renderer.createElement('span');
    onLabel.textContent = this.onText;
    onLabel.className = 'tgl-label-on'; // Add your CSS classes here

    // Create and style the "OFF" label
    const offLabel = this.renderer.createElement('span');
    offLabel.textContent = this.offText;
    offLabel.className = 'tgl-label-off'; // Add your CSS classes here

    // Append the labels to the label element
    this.renderer.appendChild(label, onLabel);
    this.renderer.appendChild(label, offLabel);

    // Replace the original element with the new label element
    this.renderer.insertBefore(this.el.nativeElement.parentElement, label, this.el.nativeElement);
    this.renderer.removeChild(this.el.nativeElement.parentElement, this.el.nativeElement);
  }
}
